<div class="bg-white slide ">
    <div class="">
        <!-- Header -->
        <div class="flex flex-col md:flex-row items-start justify-between gap-2 md:gap-4 mb-6">
            <msc-heading-actions class="block w-full">
                <div class="min-w-0">
                    <h1 class="mb-2 text-2xl font-bold text-gray-700 tracking-tight">{{ 'player.course-end.title' | translate }}</h1>
                    <p class="text-sm text-gray-500 mt-1 max-w-md">{{ 'player.course-end.recap' | translate:{ name: course?.title } }}</p>
                </div>
            </msc-heading-actions>
            <!--   <button type="button" (click)="back()"
             style="display: none !important;"  class="inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-normal  text-white transition-all duration-200 hover:scale-[1.02] hover:shadow-lg hover:text-white active:scale-[0.98] flex-shrink-0 bg-primary-500">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="w-4 h-4">
                    <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                    <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                </svg>
                {{ 'player.course-end.back' | translate }}
            </button> -->
        </div>

        <!-- Metric Cards -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">

            <!-- Progreso general -->
            <div class="rounded-2xl bg-gray-50 border border-gray-100 p-2.5">
                <p class="text-[10px] font-semibold uppercase tracking-[0.14em] text-gray-500 px-2 py-1.5">
                    {{ 'player.course-end.overall-progress' | translate | uppercase }}
                </p>
                <div class="rounded-xl bg-white border border-[#E8EAEF] px-4 py-4 min-h-[120px] flex flex-col">
                    <div class="flex items-start justify-between gap-3">
                        <h3 class="text-base font-semibold text-[#22304C]">{{ 'player.course-end.overall-progress' | translate }}</h3>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-5 h-5 shrink-0 text-[#22304C] opacity-80">
                            <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                            <path d="M18 17V9"></path>
                            <path d="M13 17V5"></path>
                            <path d="M8 17v-3"></path>
                        </svg>
                    </div>
                    <div class=" mt-3">
                        <div class="text-3xl font-bold leading-none text-[#22304C]">{{ (getOverallProgress() * 100) | number:'1.0-0' }}%</div>
                        <div class="hidden mt-3 h-1.5 rounded-full bg-[#F1F2F5] overflow-hidden">
                            <div class="hiddenh-full rounded-full" [style.width.%]="getOverallProgress() * 100"
                                style="background: hsl(var(--primary));"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Porcentaje de éxito -->
            <div class="rounded-2xl bg-gray-50 border border-gray-100 p-2.5">
                <p class="text-[10px] font-semibold uppercase tracking-[0.14em] text-gray-500 px-2 py-1.5">
                    {{ 'player.course-end.grade' | translate | uppercase }}
                </p>
                <div class="rounded-xl bg-white border border-[#E8EAEF] px-4 py-4 min-h-[120px] flex flex-col">
                    <div class="flex items-start justify-between gap-3">
                        <h3 class="text-base font-semibold text-[#22304C]">{{ 'player.course-end.grade' | translate }}</h3>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-5 h-5 shrink-0 text-[#22304C] opacity-80">
                            <circle cx="12" cy="12" r="10"></circle>
                            <circle cx="12" cy="12" r="6"></circle>
                            <circle cx="12" cy="12" r="2"></circle>
                        </svg>
                    </div>
                    <div class="mt-3 flex items-end justify-between gap-3">
                        <div>
                            <!-- getScore(): score GENERAL autoritativo desde reporting (fallback al valor local) -->
                            <ng-container *ngIf="getScore() !== null; else noScore">
                                <div class="text-3xl font-bold leading-none text-[#22304C]">{{ getScore() | number:'1.0-0' }}%</div>
                            </ng-container>
                            <ng-template #noScore>
                                <div class="text-3xl font-bold leading-none text-[#22304C]">{{ getScore() | result }}</div>
                                <p class="text-xs text-[#5F6877] mt-2">{{ 'player.course-end.exercise.no-evaluations' | translate }}</p>
                            </ng-template>
                        </div>
                        
                    </div>
                </div>
            </div>

            <!-- Tiempo dedicado -->
            <div class="rounded-2xl bg-gray-50 border border-gray-100 p-2.5">
                <p class="text-[10px] font-semibold uppercase tracking-[0.14em] text-gray-500 px-2 py-1.5">
                    {{ 'player.course-end.time-passed' | translate | uppercase }}
                </p>
                <div class="rounded-xl bg-white border border-[#E8EAEF] px-4 py-4 min-h-[120px] flex flex-col">
                    <div class="flex items-start justify-between gap-3">
                        <h3 class="text-base font-semibold text-[#22304C]">{{ 'player.course-end.time-passed' | translate }}</h3>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-5 h-5 shrink-0 text-[#22304C] opacity-80">
                            <line x1="10" x2="14" y1="2" y2="2"></line>
                            <line x1="12" x2="15" y1="14" y2="11"></line>
                            <circle cx="12" cy="14" r="8"></circle>
                        </svg>
                    </div>
                    <div class="mt-3">
                        <!-- getDurationValue(): tiempo TOTAL de dedicación al curso en SEGUNDOS; pipe time:true lo formatea -->
                        <div class="text-3xl font-bold leading-none text-[#22304C]">{{ getDurationValue() | time:true }}</div>
                        <p class="hidden text-xs text-[#5F6877] mt-2">{{ 'player.course-end.session-active' | translate }}</p>
                    </div>
                </div>
            </div>

        </div>

        <!-- Desglose por Módulos -->
        <div class="rounded-2xl border border-[#E8EAEF] bg-white overflow-hidden">
            <div class="flex items-center justify-between p-4 border-b border-[#E8EAEF]">
                <h3 class="text-base font-bold text-gray-700">{{ 'player.course-end.module-breakdown' | translate }}</h3>
                <div class="hidden flex items-center gap-4 text-xs text-gray-500">
                    <span class="inline-flex items-center gap-1.5">
                        <span class="w-2 h-2 rounded-full" style="background: hsl(var(--primary));"></span>
                        {{ 'player.course-end.progress' | translate }}
                    </span>
                    <span class="inline-flex items-center gap-1.5">
                        <span class="w-2 h-2 rounded-full bg-[#22304C]"></span>
                        {{ 'player.course-end.exercise.success' | translate }}
                    </span>
                </div>
            </div>

            <div style="    overflow-y: scroll;
       height: 50vw;">
                <div *ngFor="let section of course.sections; let index = index"
                     class="group flex items-center gap-4 p-4 border-b border-[#F1F2F5] last:border-b-0 transition-colors hover:bg-[#FFF7F9] cursor-pointer">

                    <!-- Número de sección -->
                    <span class="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold flex-shrink-0 transition-transform group-hover:scale-110"
                          style="    background: 
 color-mix(in srgb, var(--v2-color-secondary-500), white 92%);     color: var(--secondary-color);">
                        {{ (index + 1) | number:'2.0-0' }}
                    </span>

                    <!-- Título y descripción -->
                    <div class="min-w-0 flex-1">
                        <p class="text-sm font-normal text-gray-700 truncate">{{ section.title || ('player.common.untitled' | translate) }}</p>
                        
                    </div>

                    <!-- Progreso y Éxito -->
                    <div class="hidden sm:flex items-center gap-8 flex-shrink-0">
                        <div class="text-right">
                            <p class="text-[10px] text-gray-500 font-semibold">{{ 'player.course-end.progress' | translate }}</p>
                            <p class="text-sm font-bold text-gray-700">{{ (courseSubscriptionSession?.getSectionProgress(section) * 100) | number:'1.0-0' }}%</p>
                        </div>
                        <div class="text-right">
                            <p class="text-[10px] text-gray-500 font-semibold">{{ 'player.course-end.exercise.success' | translate }}</p>
                            <p class="text-sm font-bold text-gray-700">{{ courseSubscriptionSession?.getSectionScore(section) | result }}</p>
                        </div>
                    </div>

                    <!-- Icono de estado -->
                    <span class="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0">
                        <!-- Completado (100%) -->
                        <ng-container *ngIf="courseSubscriptionSession?.getSectionProgress(section) >= 1; else inProgressOrLocked">
                            <span class="w-5 h-5 rounded-full flex items-center justify-center" style="background: var(--secondary-500);">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"
                                     class="w-3 h-3 text-white">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg>
                            </span>
                        </ng-container>
                        <!-- En progreso (> 0%) -->
                        <ng-template #inProgressOrLocked>
                            <ng-container *ngIf="courseSubscriptionSession?.getSectionProgress(section) > 0; else lockedIcon">
                                <span class="w-7 h-7 rounded-full border border-[#E8EAEF] flex items-center justify-center text-gray-500">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                         class="w-4 h-4">
                                        <path d="M5 12h14"></path>
                                    </svg>
                                </span>
                            </ng-container>
                            <!-- Sin iniciar (0%) -->
                            <ng-template #lockedIcon>
                                <span class="w-7 h-7 rounded-full border border-[#E8EAEF] flex items-center justify-center text-gray-500">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                         class="w-3.5 h-3.5">
                                        <rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect>
                                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                    </svg>
                                </span>
                            </ng-template>
                        </ng-template>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
